<template>
   <section class="what__area pt-115 pb-115">
      <div class="container">
         <div class="row">
            <div class="col-xxl-6 offset-xxl-3 col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
               <div class="section__title-wrapper mb-60 text-center">
                  <h2 class="section__title"><span class="yellow-bg-big">Oportunidades
                        <img src="../../assets/img/shape/yellow-bg-2.png" alt=""></span></h2>
                  <p>Explore as oportunidades oferecidas pela UFDPar</p>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="col-xxl-5 offset-xl-1 col-xl-5 offset-xl-1 col-lg-6">
               <div class="what__item transition-3 mb-30 p-relative fix">
                  <div class="what__thumb w-img">
                     <img src="../../assets/img/what/what-1.jpg" alt="">
                  </div>
                  <div class="what__content p-absolute text-center">
                     <h3 class="what__title white-color">Pós-Graduação <br> Stricto Sensu</h3>
                     <a href="https://ufdpar.edu.br/propopi/paginas/pos-graduacao-stricto-sensu"
                        class="e-btn e-btn-border-2" target="_blank" rel="noopener noreferrer">
                        Conheça nossos cursos
                     </a>
                  </div>
               </div>
            </div>

            <div class="col-xxl-5 col-xl-5 col-lg-6">
               <div class="what__item transition-3 mb-30 p-relative fix">
                  <div class="what__thumb w-img">
                     <img src="../../assets/img/what/what-2.jpg" alt="">
                  </div>
                  <div class="what__content p-absolute text-center">
                     <h3 class="what__title white-color">Pós-Graduação <br> Lato Sensu</h3>
                     <a href="https://ufdpar.edu.br/propopi/paginas/pos-graduacao-lato-sensu"
                        class="e-btn e-btn-border-2" target="_blank" rel="noopener noreferrer">
                        Conheça nossos cursos
                     </a>
                  </div>
               </div>
            </div>

         </div>
      </div>
   </section>
</template>

<script>
export default {
   name: 'WhatArea'
};
</script>
